import { IonAlert, IonToast } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setShowAbandonModal } from "../../../store/documentShow";
import { selectDocument } from "../../../store/documentShow/selectors/selectDocument";
import { setAbandonStatus } from "../../../store/documentUpdate";
import { selectAbandonStatus } from "../../../store/documentUpdate/selectors/selectAbandonStatus";
import { addDocumentHistory } from "../../../store/documentUpdate/actions/addDocumentHistory";
import { abandonDocument } from "../../../store/documentUpdate/actions/abandonDocument";
import { selectShowAbandonModal } from "../../../store/documentShow/selectors/selectShowAbandonModal";

export const AbandonDocument = () => {
  const dispatch = useDispatch();
  const showAlert = useSelector(selectShowAbandonModal);
  const abandonStatus = useSelector(selectAbandonStatus);
  const document = useSelector(selectDocument);

  return (
    <>
      {document.status?.name !== "Abandonado" && (
        <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => dispatch(setShowAbandonModal(false))}
          header="¿Seguro que quieres marcar este acuerdo como abandonado?"
          buttons={[
            "Volver",
            {
              text: "marcar como abandonado",
              handler: (d) => {
                dispatch(abandonDocument());
                dispatch(addDocumentHistory("marcó el acuerdo como abandonado"));
              },
            },
          ]}
        />
      )}

      <IonToast
        isOpen={abandonStatus === "fulfilled"}
        message="Acuerdo marcado como abandonado correctamente"
        position="top"
        onWillDismiss={() => dispatch(setAbandonStatus(""))}
        duration={6000}
        color="success"
      />

      <IonToast
        isOpen={abandonStatus === "pending"}
        message="Abandonando acuerdo..."
        position="top"
        duration={6000}
        color="primary"
      />
    </>
  );
};
